"use client";

import { Typography } from "@/components/Typography/Typography.component";
import { useBreakpoints } from "@/hooks/useBreakpoints/useBreakpoints";
import { cn } from "@/lib/utils";
import { COLOR_PICKER } from "@/types/Contentful.model";
import { useEffect, useRef, useState } from "react";
import { CapabilityProductsPropsModel } from "./CapabilityProducts.model";

const CapabilityProducts = ({
  title,
  description,
  backgroundColor,
  capabilityOfferingsCollection: items,
}: CapabilityProductsPropsModel) => {
  const capabilityProductsRef = useRef<HTMLDivElement>(null);
  const [capabilityProductsHeight, setCapabilityProductsHeight] =
    useState<number>(0);
  const { isMobile } = useBreakpoints();

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (capabilityProductsRef?.current) {
        setCapabilityProductsHeight(
          capabilityProductsRef?.current?.clientHeight,
        );
      }
    });
    if (capabilityProductsRef.current) {
      resizeObserver.observe(capabilityProductsRef.current);
    }
    if (capabilityProductsRef.current) {
      resizeObserver.observe(capabilityProductsRef.current);
    }
    // Clean up observer on unmount
    return () => {
      resizeObserver.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, isMobile]);

  return (
    <div
      className={cn(
        `bg-${COLOR_PICKER[backgroundColor.name as keyof typeof COLOR_PICKER]}`,
        "capability-products relative w-full overflow-visible",
      )}
      style={{ height: `${capabilityProductsHeight}px` }}
    >
      <div
        className={cn(
          "text-core-white",
          "capability-products__content px-sm py-lg md:px-lg md:py-xxxl absolute w-full",
        )}
        ref={capabilityProductsRef}
      >
        <div className="capability-products__items gap-y-xxl md:mb-xxs mb-0 grid grid-cols-1 gap-x-4 px-0 md:grid-cols-2 md:px-[20%]">
          <div className="col-span-1 max-w-[338px]">
            <Typography.LLABEL1 className="capability-products__title pb-md">
              {title}
            </Typography.LLABEL1>
            {description && (
              <Typography.H3Sentence>{description}</Typography.H3Sentence>
            )}
          </div>
          <div className="col-span-1 flex flex-col gap-2">
            {items.map((item, index) => {
              return (
                <div
                  key={index}
                  className="bg-core-black gap-sm md:gap-md flex flex-col rounded-lg p-6"
                >
                  <Typography.H6>{item.title}</Typography.H6>
                  <Typography.BODY2>{item.description}</Typography.BODY2>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapabilityProducts;
